import { memo } from 'react';
import { useTheme } from '@mui/material';
import NoAssignmentsIllustrationLight from './noAssignments.svg?react';
import NoAssignmentsIllustrationDark from './noAssignments_dark.svg?react';

export const NoAssignmentsIllustration = memo(
  (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();

    if (theme.palette.type === 'dark')
      return <NoAssignmentsIllustrationDark aria-hidden="true" {...props} />;
    return <NoAssignmentsIllustrationLight aria-hidden="true" {...props} />;
  },
);
